export const personalizationName = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  justifyContent: "center",
  userSelect: "none",
  pointerEvents: "none",
  height: "100%",
};

export const personalizationNameInner = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  justifyContent: "center",
  position: "relative",
  whiteSpace: "nowrap",
};

export const name = {
  fontFamily: "body",
  fontWeight: "body",
  fontSize: ({ isMobile }) => (isMobile ? "120px" : "480px"),
  lineHeight: "1",
  letterSpacing: "0.01em",
  textTransform: "uppercase",
  color: "coolGrey9",
  opacity: "0.3",
};

export const number = {
  ...name,
  fontSize: ({ isMobile }) => (isMobile ? "60px" : "240px"),

  position: "absolute",
  right: "0",
  top: "100%",
};

export const engineeredFor = {
  ...name,
  fontSize: ({ isMobile }) => (isMobile ? "60px" : "240px"),

  position: "absolute",
  right: "0",
  top: "85%",
};
